type CardDurationCellProps = {
    duration: string;
};

export const DurationCell = ({ duration }: CardDurationCellProps) => (
    <div className='display-flex gap-5'>
        <span className='uikit-icon icon-time-alt text-size-20' /> {duration}{' '}
    </div>
);
